exports["FR"] = require("./FR.js");